<template>
    <Card :bordered="false" :padding="0" dis-hover>
        <template v-if="myConfig.modetype === '1'">
        <p  @click="toggle" style="cursor:pointer;" >
            <Row type="flex" justify="start" align="middle" style="margin-top:14px;margin-bottom:14px">
                <CommonIcon type='_custom-pack' v-show="showForm" size="14"/>  <CommonIcon  v-show="!showForm" type='_custom-spread' size="14"/> <span style="margin-left:10px;font-size: 14px;font-weight:bold" v-text="myConfig.title" />
            </Row>
        </p>
      
        <Divider style="margin-left:24px;margin-top:0px;margin-bottom:10px;"/>
        <Form ref="form" v-show="showForm" :model="form" :rules="formRules" :label-position="myConfig.labelPosition" :label-width="myConfig.labelWidth" :inline="myConfig.inline" :id="myConfig.name" @submit.native.prevent>
            <Row type="flex" justify="start">
                <Col v-for="(item,index) in items" v-if="item.status" :span="initFormItemCol(index)" v-show="item.visible !== false" class="efuture-form" >
                    <FormItem v-if="item.type !== 'Divider' && item.status && item.visible !== false"  :prop="item.name||item.sname"  :style="getFormItemStyle(item)" :show-message="false">
                        <ShowText slot="label"  style="padding-left:10px"  :contentAlign="myConfig.labelPosition" :label="item.label"></ShowText>
                        <ControlBox  :ref="item.name||item.sname"  :valueData="form" :config="item" @input="input"   @doAction="doAction" ></ControlBox>
                    </FormItem>
                    <ControlBox  v-if="item.type === 'Divider'"  style="margin-left:32px;" :config="item"></ControlBox>
                </Col>
            </Row>
        </Form>
        </template>
        <template v-if="myConfig.modetype === '2'">
            <p style="border-left: 4px solid #AF292E;padding-left:10px;margin-bottom:20px">
                <span style="font-size: 14px;font-weight:bold" v-text="myConfig.title" />
            </p>
            <Form ref="form" v-show="showForm" :model="form" :rules="formRules" :label-position="myConfig.labelPosition" :label-width="myConfig.labelWidth" :inline="myConfig.inline" :id="myConfig.name" @submit.native.prevent>
            <Row type="flex" justify="start">
                <Col v-for="(item,index) in items" v-if="item.status" :span="initFormItemCol(index)" v-show="item.visible !== false" class="efuture-form">
                    <FormItem v-if="item.type !== 'Divider' && item.status && item.visible !== false"  :prop="item.name||item.sname"  :style="getFormItemStyle(item)" :show-message="false">
                        <ShowText slot="label"  :contentAlign="myConfig.labelPosition" :label="item.label"></ShowText>
                        <ControlBox  :ref="item.name||item.sname"  :valueData="form" :config="item" @input="input"   @doAction="doAction" ></ControlBox>
                    </FormItem>
                    <ControlBox  v-if="item.type === 'Divider'"  :config="item"></ControlBox>
                </Col>
            </Row>
        </Form>
        </template>    
    </Card>
</template>

<script>
import Base from '@/components/form/formbox.vue';
export default {
    name:'formcard',
    extends: Base,
    data () {
        return {
            myConfig:{
                title:'',
                modetype:'1'
            },
            showForm:true,
            editFlag:false,
            showTitle:false
        };
    },
    methods:{
        toggle () {
          this.showForm = !this.showForm;
        },
        setShowForm(value) {
            this.showForm = value;
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/masterplate/formcard.vue